import { combineReducers } from 'redux';
import actionTypeDirections from './actionTypeDirections';
import advertisingLawForm from './advertisingLawForm';
import agreement from './agreement';
import app from './app';
import auth from './auth';
import apiAuth from './apiAuth';
import backurl from './backurl';
import bannerRotator from './bannerRotator';
import channels from './channels';
import contactTypes from './contactTypes';
import couponSectors from './couponSectors';
import creative from './creative';
import currency from './currency';
import dashboard from './dashboard';
import dataGrid from './dataGrid';
import domainParking from './domainParking';
import { entities } from 'redux-entity';
import fab from './fab';
import finance from './finance';
import feedback from './feedback';
import footer from './footer';
import { reducer as hamster } from 'hamster-redux';
import header from './header';
import home from './home';
import language from './language';
import log from './log';
import lostOrders from './lostOrders';
import news from './news';
import menu from './menu';
import monitoring from './monitoring';
import offerReward from './offerReward';
import offers from './offers';
import paginator from './paginator';
import { routerReducer } from 'react-router-redux';
import shortLink from './shortLink';
import showcases from './showcases';
import selectList from './selectList';
import sms from './sms';
import social from './social';
import storedSettings from './storedSettings';
import subscriptionStatuses from './subscriptionStatuses';
import timeZones from './timeZones';
import trafficTypes from './trafficTypes';
import trustLevels from './trustLevels';
import webmasterTypes from './webmasterTypes';
import welcomeform from './welcomeform';
import widgets from './widgets';
import wmOfferUrls from './wmOfferUrls';
import zaleyCash from './zaleyCash';

const rootReducer = combineReducers({
  actionTypeDirections,
  advertisingLawForm,
  agreement,
  app,
  auth,
  apiAuth,
  backurl,
  bannerRotator,
  channels,
  contactTypes,
  couponSectors,
  creative,
  currency,
  dashboard,
  dataGrid,
  domainParking,
  entities,
  fab,
  feedback,
  finance,
  footer,
  hamster,
  header,
  home,
  language,
  log,
  lostOrders,
  menu,
  monitoring,
  news,
  offerReward,
  offers,
  paginator,
  selectList,
  sms,
  social,
  storedSettings,
  routerReducer,
  shortLink,
  showcases,
  subscriptionStatuses,
  timeZones,
  trafficTypes,
  trustLevels,
  webmasterTypes,
  welcomeform,
  widgets,
  wmOfferUrls,
  zaleyCash,
});

export default rootReducer;
